/* unplugin-vue-components disabled */import { render } from "./MultipleOption.vue?vue&type=template&id=4c830205&scoped=true"
import script from "./MultipleOption.vue?vue&type=script&lang=js"
export * from "./MultipleOption.vue?vue&type=script&lang=js"

import "./MultipleOption.vue?vue&type=style&index=0&id=4c830205&scoped=true&lang=css"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c830205"]])

export default __exports__